import React from 'react';
import Header from './header/Header';
import Contact from './Contact';
import SEO from './SEO';
import { LanguageProvider } from '../../context/LanguageContext';

const LayoutInner = ({ children, seo }) => (
  <>
    <SEO {...(seo || {})} />
    <Header />
    {children}
    <Contact />
  </>
);

const Layout = ({ children, seo }) => (
  <LanguageProvider>
    <LayoutInner seo={seo}>
      {children}
    </LayoutInner>
  </LanguageProvider>
);

export default Layout;
